import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useDayPicker } from 'contexts/DayPicker';
/**
 * Render the wrapper for the month grids.
 */
export function Months(props) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    return (_jsx("div", __assign({ className: classNames.months, style: styles.months }, { children: props.children })));
}
//# sourceMappingURL=Months.js.map